import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ApplicationBuilder from "@/modules/application/admin/components/ApplicationBuilder";

export const Route = createFileRoute(
  "/admin/_panel/_application/application/applications/create",
)({
  component: Component,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "application.application.create");

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Create Process", { ns: "application.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
});

function Component() {
  return <ApplicationBuilder step={0} />;
}
